var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fancybox-container-16 container", attrs: { id: "covid" } },
    [
      _c("div", { staticClass: "row bg-white py-3 px-1" }, [
        _c(
          "div",
          { staticClass: "col-md-7" },
          [
            _vm._t("image", function() {
              return [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v("PUT YOUR IMAGE HERE")
                ])
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _vm._t("text", function() {
              return [
                _c("p", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Error neque vel, quo, commodi delectus dolorem reprehenderit accusamus vero laboriosam cupiditate reiciendis maxime, minima assumenda accusantium cum veniam eaque et impedit."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem commodi quas aut, non nulla aspernatur ipsum voluptatum dolorem itaque, eligendi eius fuga repellat esse. Nesciunt numquam totam voluptatibus praesentium ullam."
                  )
                ])
              ]
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }